import React, { Component } from 'react'
import '../css/BisharatMain.css';
import familytreeImg from "../data/images/backtreeins.jpg";
import translate from '../languages/translate';
import AuthService from '../services/AuthService';


export default class FamilyTreeInstruction extends Component {


  render() {

    const goToProfile = () => {
      window.location = '/profile';
  }

    const loggedInUser = AuthService.getCurrentUser();
    const whatRole = AuthService.getUserRole();
   
    return (
      <div className="family-tree-instructions">
  <div className="img-for-tree">
      <img src={familytreeImg} alt="nice"></img>
  </div>

          <div className="inst-for-tree">
  <h1>{translate("some-instructions")}   </h1>
  <li>{translate("members-entrance")}
  </li>
  <li>{translate("use-chrome")}</li>
  <li>{translate("scroll-sides")}</li>
  <li>{translate("click-to-open")}</li>
  <li>{translate("see-full-profile")}</li>
  <br></br>
  <li>   {translate("last-update")}  24-10-2014 </li>
  <li>   {translate("next-update")}  2021</li>
  <br></br>
      {!loggedInUser || (whatRole === ('USER')) ? 
      <>
        <p className="alertDanger">  {translate("family-per-content")}    </p>
      <button className="btn-small" onClick={goToProfile}> {translate("request-family-permissions")}   </button>  
      </> : 
      <>
        <a href="/family-tree/463ded4f-6720-41cf-a8dd-a01475fb92a2"> {translate("familytree")} </a>
      </>
    }

  
  </div>

      </div>
    )
  }
}
